import { PAGES, type PageInfo } from "./pages";

import GeoInfraMonitoringImg from "../assets/pages/home/hero/geo-infra-monitoring.jpg";
import DesignImg from "../assets/pages/home/hero/design.jpg";
import EnergyEfficiencyImg from "../assets/pages/home/hero/energy-efficiency.jpg";
import EnvironmentalProtectionImg from "../assets/pages/home/hero/environmental-protection.jpg";
import FireProtectionImg from "../assets/pages/home/hero/fire-protection.jpg";
import FirstAidImg from "../assets/pages/home/hero/first-aid.jpg";
import InspectionsTestingImg from "../assets/pages/home/hero/inspections-testing.jpg";
import PredictiveMaintenanceImg from "../assets/pages/home/hero/predictive-maintenance.jpg";
import ProfessionalTrainingImg from "../assets/pages/home/hero/professional-training.jpg";
import SiteSafetyCoordinatorImg from "../assets/pages/home/hero/site-safety-coordinator.jpg";
//import StandardizationImg from "../assets/pages/home/hero/standardization.jpg";
import SupervisionImg from "../assets/pages/home/hero/supervision.jpg";
import WorkSafetyHealthImg from "../assets/pages/home/hero/work-safety-health.jpg";

export type NavigationItem = PageInfo & {
  dropdown?: ( PageInfo & { imageUrl?: string; heroImagePosition?: string; } )[];
};

export const headerNavigationConstants: NavigationItem[] = [
  PAGES.HOME,
  PAGES.ABOUT,
  {
    ...PAGES.SERVICE,
    dropdown: [
      {
        ...PAGES.GEO_INFRA_MONITORING,
        imageUrl: GeoInfraMonitoringImg,
        heroImagePosition: "center 75%",
      },
      {
        ...PAGES.SUPERVISION,
        imageUrl: SupervisionImg,
        heroImagePosition: "center 15%",
      },
      {
        ...PAGES.PREDICTIVE_MAINTENANCE,
        imageUrl: PredictiveMaintenanceImg,
        heroImagePosition: "center 70%",
      },
      {
        ...PAGES.WORK_SAFETY_HEALTH,
        imageUrl: WorkSafetyHealthImg,
        heroImagePosition: "center 45%",
      },
      { ...PAGES.SITE_SAFETY_COORDINATOR, imageUrl: SiteSafetyCoordinatorImg },
      { ...PAGES.ENERGY_EFFICIENCY, imageUrl: EnergyEfficiencyImg },
      { ...PAGES.DESIGN, imageUrl: DesignImg },
      {
        ...PAGES.FIRE_PROTECTION,
        imageUrl: FireProtectionImg,
        heroImagePosition: "center 30%",
      },
      {
        ...PAGES.ENVIRONMENTAL_PROTECTION,
        imageUrl: EnvironmentalProtectionImg,
        heroImagePosition: "center 80%",
      },
      //{ ...PAGES.STANDARDIZATION, imageUrl: StandardizationImg },
      {
        ...PAGES.FIRST_AID,
        imageUrl: FirstAidImg,
        heroImagePosition: "center 25%",
      },
      { ...PAGES.PROFESSIONAL_TRAINING, imageUrl: ProfessionalTrainingImg },
      {
        ...PAGES.INSPECTIONS_TESTING,
        imageUrl: InspectionsTestingImg,
        heroImagePosition: "center 75%",
      },
    ],
  } as NavigationItem,
  PAGES.LICENSE,
  PAGES.CONTACT,
];

export const footerNavigationConstants: NavigationItem[] = [
  PAGES.HOME,
  PAGES.ABOUT,
  PAGES.LICENSE,
  PAGES.CONTACT,
  {
    ...PAGES.SERVICE,
    dropdown: [
      PAGES.GEO_INFRA_MONITORING,
      PAGES.SUPERVISION,
      PAGES.PREDICTIVE_MAINTENANCE,
      PAGES.WORK_SAFETY_HEALTH,
      PAGES.SITE_SAFETY_COORDINATOR,
      PAGES.ENERGY_EFFICIENCY,
      PAGES.DESIGN,
      PAGES.FIRE_PROTECTION,
      PAGES.ENVIRONMENTAL_PROTECTION,
      PAGES.STANDARDIZATION,
      PAGES.FIRST_AID,
      PAGES.PROFESSIONAL_TRAINING,
      PAGES.INSPECTIONS_TESTING,
    ],
  } as NavigationItem,
];
